import React, { useState } from "react";
import CartModal from "../../Components/CartModal";
import { useCart } from "../../Contexts/CartContext";
import Oasis_cube_shop1 from "../../Assets/oasis_cube_shop1.webp";
import Oasis_cube_shop2 from "../../Assets/oasis_cube_shop2.webp";
import Oasis_cube_shop3 from "../../Assets/oasis_cube_shop3.webp";
import Oasis_cube_shop4 from "../../Assets/oasis_cube_shop4.webp";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tab, Nav, Carousel } from "react-bootstrap";
import "../../App.css";

const Oasis_cube_shop = () => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    const product = {
      id: 60,
      name: "Oasis Cube",
      price: 250,
      image: Oasis_cube_shop1,
    };
    addToCart({ ...product, quantity: 1 });
    setShowModal(true);
  };

  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-md-6">
          <Carousel>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={Oasis_cube_shop1}
                alt="growing tray"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={Oasis_cube_shop2}
                alt="growing tray for microgreens"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={Oasis_cube_shop3}
                alt="fodder tray"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={Oasis_cube_shop4}
                alt="microgreen tray"
              />
            </Carousel.Item>
          </Carousel>
        </div>

        <div className="col-md-6">
          <div className="product-details">
            <h2 className="product-name">
              Oasis Cube – Hydroponic Growing Medium for Seed Germination
            </h2>
            <p className="product-price">
              <a href="/Contact" className="btn btn-link">
                Contact Us for Price Details
              </a>
            </p>

            {/* <button className="btn btn-primary" onClick={handleAddToCart}>
              Add to Cart
            </button> */}

            <div className="row mt-4">
              <div className="col-12">
                <p className="text-justify">
                  <h4>
                    Clean, Consistent & High-Performance Medium for Seed
                    Starting
                  </h4>
                  Oasis Cubes are specialized foam-based growing media designed
                  for fast and uniform seed germination in hydroponic systems.
                  Lightweight, pH-stable, and inert, they support optimal
                  moisture and air balance, making them ideal for commercial
                  nurseries, greenhouses, and hydroponic farms.
                </p>
                <i>Note: Minimum Order Quantity: 100 Sheets</i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs Section with Border */}
      <div className="row mt-4">
        <div className="col-12 border-tabs">
          <Tab.Container defaultActiveKey="Specifications">
            <Nav variant="tabs" className="mb-3 custom-nav">
              <Nav.Item>
                <Nav.Link eventKey="Specifications" className="custom-tab">
                  Product Specifications
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="Features" className="custom-tab">
                  Features
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="moreInfo" className="custom-tab">
                  Additional Information
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content>
              <Tab.Pane eventKey="Specifications">
                <ul>
                  <li>
                    <span className="fw-bold">Material:</span> Phenolic foam
                    (biologically inert, sterile, non-toxic)
                  </li>
                  <li>
                    <span className="fw-bold">Dimensions:</span> 20” x 10” x
                    1.5” (standard), customizable sizes on request
                  </li>
                  <li>
                    <span className="fw-bold">Hole size:</span> Pre-punched for
                    uniform spacing and seed placement
                  </li>
                  <li>
                    <span className="fw-bold">Color:</span> Dark brown or green
                  </li>
                  <li>
                    <span className="fw-bold">Moisture retention:</span>{" "}
                    Excellent water-holding capacity with rapid drainage
                  </li>
                  <li>
                    <span className="fw-bold">pH range:</span> Neutral and
                    stable
                  </li>
                  <li>
                    <span className="fw-bold">Compatibility:</span> Suitable for
                    NFT, DWC, Dutch bucket, and other systems
                  </li>
                </ul>
              </Tab.Pane>

              <Tab.Pane eventKey="Features">
                <h4>Features</h4>
                <ul>
                  <li>
                    Scalable: Suitable for commercial nurseries and indoor
                    setups
                  </li>
                  <li>
                    Efficient Moisture Management: Holds water without becoming
                    soggy
                  </li>
                  <li>Modular Design: Fits standard growing trays</li>
                  <li>
                    Strong Support Structure: Holds seedlings upright during
                    early stages
                  </li>
                  <li>
                    Eco-Friendly Disposal: Decomposes slowly without
                    contaminating the environment
                  </li>
                </ul>
              </Tab.Pane>

              <Tab.Pane eventKey="moreInfo">
                <h4>Additional Information</h4>
                <ul>
                  <li>
                    <span className="fw-bold">Item Code:</span> RGCPL-0040
                  </li>
                  <li>
                    <span className="fw-bold">Delivery Time:</span> 7-8 Days
                  </li>
                  <li>
                    <span className="fw-bold">Port of Dispatch:</span>{" "}
                    Maharashtra, India
                  </li>
                  <li>
                    <span className="fw-bold">Production Capacity:</span> 2,000+
                    Sheets Per Day
                  </li>
                  <li>
                    <span className="fw-bold">Packaging Details:</span> Bundled
                    in shrink-wrapped stacks or boxed as per client needs
                  </li>
                  <li>
                    <span className="fw-bold">Payment Terms:</span> Advance
                    Payment
                  </li>
                  <li>
                    <span className="fw-bold">Payment Mode:</span> RTGS / NEFT /
                    IMPS
                  </li>
                </ul>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>

        <h5 className="mt-3">Key Benefits:</h5>
        <ul>
          <li>
            Promotes Uniform Germination: Balanced water-to-air ratio supports
            fast root development
          </li>

          <li>
            pH-Stable & Non-Toxic: Will not affect nutrient solution balance
          </li>

          <li>
            Root Zone Visibility: Easy to inspect seedling health and root
            growth
          </li>

          <li>
            Easy Transplantation: Cubes can be cleanly cut and moved without
            disturbing roots
          </li>

          <li>
            Sterile Growing Conditions: Reduces risk of pathogens, mold, or root
            rot
          </li>
          <li>
            Media-Free Transplant: Transitions easily into net pots or channels
          </li>
        </ul>

        <h5 className="mt-3">Applications:</h5>
        <ul>
          <li>Commercial hydroponic nurseries and seedling propagation</li>

          <li>Leafy greens, herbs, and flowering crops</li>

          <li>Controlled environment agriculture (CEA)</li>

          <li>Greenhouses, indoor farms, and research facilities</li>
          <li>
            Ideal for transplanting into NFT, DWC, Dutch Bucket & Growbag
            systems
          </li>
        </ul>
      </div>

      {showModal && <CartModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default Oasis_cube_shop;
